/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { connect } from 'react-redux'

import type { AsyncRequestState, Keystore, StackDeployment } from '@modules/ui-types'

import { getFirstEsClusterFromGet } from '@/lib/stackDeployments/selectors/fundamentals'
import { createSecretRequest } from '@/reducers/asyncRequests/registry'

import { addSecretToKeystore } from '../../../../actions/keystore'

import ManageKeystore from './ManageKeystore'

import type { ThunkDispatch, ReduxState } from '@/types/redux'

type StateProps = {
  createSecretRequest: AsyncRequestState
}

type DispatchProps = {
  addSecretToKeystore: (secrets: Keystore) => void
}

type ConsumerProps = {
  deployment: StackDeployment
}

const mapStateToProps = (state: ReduxState, { deployment }: ConsumerProps): StateProps => {
  const { ref_id } = getFirstEsClusterFromGet({ deployment })!

  return {
    createSecretRequest: createSecretRequest(state, deployment.id, ref_id),
  }
}

const mapDispatchToProps = (
  dispatch: ThunkDispatch,
  { deployment }: ConsumerProps,
): DispatchProps => {
  const { ref_id } = getFirstEsClusterFromGet({ deployment })!

  return {
    addSecretToKeystore: (secrets: Keystore) =>
      dispatch(addSecretToKeystore(deployment.id, ref_id, secrets)),
  }
}

export default connect<StateProps, DispatchProps, ConsumerProps>(
  mapStateToProps,
  mapDispatchToProps,
)(ManageKeystore)
